export default "__VITE_ASSET__BWX8wHxT__"